import { graphql } from '@/generated/gql';

export const INTAKE_TACTICAL_SOURCING_SKIP_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeTacticalSourcingSkip($data: SvbrgTacticalSourcingInput!) {
    sevenbridges {
      chatSession {
        tacticalSourcing {
          skip(data: $data)
        }
      }
    }
  }
`);

export const INTAKE_TACTICAL_SOURCING_START_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeTacticalSourcingStart($data: SvbrgTacticalSourcingInput!) {
    sevenbridges {
      chatSession {
        tacticalSourcing {
          start(data: $data)
        }
      }
    }
  }
`);
